import { teacherServiceURL } from '../../endpoint';

export function getActivityInsightsURL(activityInstanceId: number) {
  const url = new URL(teacherServiceURL);
  url.pathname += `activities/${activityInstanceId}/insights`;
  return url;
}

export function generateActivityInsightsURL(activityInstanceId: number) {
  const url = new URL(teacherServiceURL);
  url.pathname += `ai/${activityInstanceId}/insights/`;
  return url;
}
